import { FormOverrideAddress } from '@domgen/dgx-fe-forms/address';

export interface CLPQuotePersonSummary {
  address: FormOverrideAddress;
  fullName: string;
}
